import React from 'react';
import Modal from 'react-modal';
import './GateModal.css';
import { getBrandingForDomain } from '../../utils/PlatformBranding';
import { truncate } from '../../utils/StringUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function GateModal({ isOpen, handleClose, gates, onCompleteGate, completedSteps, url, title }) {
  const handleGateClick = (link, index) => {
    window.open(link, '_window');
    setTimeout(() => onCompleteGate(index), 4000);
  };

  const stepsCompleted = `Complete to unlock (${completedSteps.length}/${gates.length})`;

  // Function to handle opening the URL and closing the modal
  const handleOpenURL = () => {
    window.open(url, '_blank');
    handleClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      contentLabel="Gate Modal"
      className="gate-modal"
      overlayClassName="gate-modal-overlay"
    >
      <button className="close-button" onClick={handleClose}>&#10005;</button>
      <h2>{stepsCompleted}</h2>
      <ul>
        {gates.map((gate, index) => (
          <li key={index}>
            <button
              onClick={() => handleGateClick(gate.link, index)}
              style={{
                backgroundColor: getBrandingForDomain(gate.link).color
              }}
              className={completedSteps.includes(index) ? "gate-button done" : "gate-button"}
            >
                {completedSteps.includes(index) ? 
                <FontAwesomeIcon icon={["fas", "check"]} />
                : 
                <FontAwesomeIcon icon={[getBrandingForDomain(gate.link).pack, getBrandingForDomain(gate.link).icon]} />
                }
              <span>{gate.action ? gate.action : truncate(gate.link)}</span>
            </button>
          </li>
        ))}
      </ul>
      <hr/>
      <button
        onClick={handleOpenURL}
        style={{
          backgroundColor: completedSteps.length === gates.length ? getBrandingForDomain(url).color : "gray",
          opacity: completedSteps.length === gates.length ? 1 : 0.6,
          cursor: completedSteps.length === gates.length ? 'pointer' : 'help'
        }}
        title={completedSteps.length >= gates.length ? '' : 'Complete all steps above first'}
        className="reward-button"
        disabled={completedSteps.length !== gates.length}
      >
        <FontAwesomeIcon icon={["fas", completedSteps.length === gates.length ? "lock-open" : "lock"]} />
        <span>{title}</span>
      </button>
    </Modal>
  );
}

export default GateModal;
